<template>
  <div class="icon-container" :style="iconContainerElStyles">
    <span :style="{ color: icon.iconColor.value }">
      <Icon :icon="iconifyName" />
    </span>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";

export default {
  name: "BenefitUIIcon",
  components: { Icon },
  props: {
    icon: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    iconifyName() {
      // fallback for missing/empty name
      return this.icon && this.icon.name ? `fa6-solid:${this.icon.name}` : "";
    },
    iconContainerElStyles() {
      const { iconColor, showBackgroundColor } = this.icon;

      // 1c is alpha in 8 digit hex notation (00 - ff) at 6.25 stops (6.25 * 16 = 100)
      const styles = {
        backgroundColor: showBackgroundColor
          ? iconColor.value + "1c"
          : "initial",
      };
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-container {
  border-radius: 50px;
  padding: 12px;
  display: grid;
  place-content: center;
  aspect-ratio: 1;
}

svg {
  height: 32px;
  width: 32px;
}
</style>
